import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1A0505] text-white pt-24 pb-12 border-t border-[#D4AF37]/20" data-id="element-51">
      <div className="max-w-7xl mx-auto px-6" data-id="element-52">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 mb-20" data-id="element-53">
          {/* Brand & Newsletter */}
          <div className="lg:col-span-5" data-id="element-54">
            <img src="https://cdn.magicpatterns.com/uploads/f1H78FhTX8Y2SRCb3UEDhx/ChatGPT_Image_Jun_12,_2026,_11_15_32_PM.png" alt="Cork Dorx Logo" className="h-32 w-auto mb-12 object-contain" data-id="element-55" />
            <p className="text-white/70 text-lg mb-10 max-w-md font-serif italic" data-id="element-56">
              "An elegant sanctuary for the modern wine enthusiast, where luxury
              meets the warmth of the valley."
            </p>
            <div className="space-y-4" data-id="element-57">
              <h4 className="mb-4" data-id="element-58">Join the Journal</h4>
              <div className="flex max-w-md border-b border-white/30 pb-2" data-id="element-59">
                <input type="email" placeholder="Your Email Address" className="bg-transparent border-none focus:ring-0 text-white placeholder:text-white/30 w-full py-2" data-id="element-60" />
                <button className="uppercase text-xs font-bold tracking-widest hover:text-[#D4AF37] transition-colors" data-id="element-61">
                  Subscribe
                </button>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="lg:col-span-3" data-id="element-62">
            <h4 className="mb-8" data-id="element-63">Menu</h4>
            <ul className="space-y-4" data-id="element-64">
              <li data-id="element-65">
                <Link to="/" className="text-white/60 hover:text-white transition-colors uppercase text-[10px] md:text-xs font-bold tracking-[0.2em]" data-id="element-66">
                  Home
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/about" className="text-white/60 hover:text-white transition-colors uppercase text-[10px] md:text-xs font-bold tracking-[0.2em]" data-id="element-68">
                  About Cork Dorx
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/services" className="text-white/60 hover:text-white transition-colors uppercase text-[10px] md:text-xs font-bold tracking-[0.2em]" data-id="element-70">
                  Services & Experiences
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/blog" className="text-white/60 hover:text-white transition-colors uppercase text-[10px] md:text-xs font-bold tracking-[0.2em]" data-id="element-72">
                  Wine Journal / Blog
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/contact" className="text-white/60 hover:text-white transition-colors uppercase text-[10px] md:text-xs font-bold tracking-[0.2em]" data-id="element-74">
                  Contact & Booking
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div className="lg:col-span-4" data-id="element-75">
            <h4 className="mb-8" data-id="element-76">Connect</h4>
            <div className="space-y-6 text-white/60" data-id="element-77">
              <p className="text-sm tracking-widest font-light" data-id="element-78">
                123 Wine Valley Road, Temecula, CA 92591
              </p>
              <p className="text-sm tracking-widest font-light" data-id="element-79">
                Reservations: (951) 555-0123
              </p>
              <p className="text-sm tracking-widest font-light" data-id="element-80">
                Inquiries: hello@corkdorx.com
              </p>
              <div className="flex space-x-6 pt-4" data-id="element-81">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-82">
                  <Instagram size={20} data-id="element-83" />
                </a>
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-84">
                  <Facebook size={20} data-id="element-85" />
                </a>
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-86">
                  <Twitter size={20} data-id="element-87" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] uppercase tracking-[0.3em] font-bold text-white/30" data-id="element-88">
          <p data-id="element-89">© 2026 Cork Dorx Luxury Hospitality Group</p>
          <div className="flex space-x-8" data-id="element-90">
            <a href="#" className="hover:text-white transition-colors" data-id="element-91">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-92">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}